import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { featuredCoverage, clientCoverage } from "@/data/press";

const tabs = [
  { key: "featured", label: "Featured", data: featuredCoverage },
  { key: "clients", label: "More Coverage", data: clientCoverage },
];

export const Press = ({ standalone = false }) => {
  const [active, setActive] = useState("featured");
  const current = tabs.find((t) => t.key === active);

  return (
    <section id="engagements" data-testid="engagements-section" className={`bg-ivory ${standalone ? "py-24" : "py-24 sm:py-32"}`}>
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <p className="overline text-gold-dark mb-6">Selected engagements</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Where our work has landed.
            </h2>
          </div>
          <div className="flex gap-2" role="tablist">
            {tabs.map((t) => (
              <button
                key={t.key}
                role="tab"
                aria-selected={active === t.key}
                data-testid={`coverage-tab-${t.key}`}
                onClick={() => setActive(t.key)}
                className={`overline px-5 py-3 border transition-colors ${
                  active === t.key ? "bg-navy text-ivory border-navy" : "border-navy/20 text-navy/60 hover:border-navy/50"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="border-t border-navy/15">
          {current.data.map((item, i) => (
            <motion.a
              key={item.url + i}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`coverage-item-${active}-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 8) * 0.03 }}
              className="group grid grid-cols-[1fr_auto] sm:grid-cols-[16rem_1fr_5rem_2rem] items-baseline gap-x-6 gap-y-1 border-b border-navy/15 py-6 hover:bg-navy transition-colors duration-400 px-2 -mx-2"
            >
              <span className="overline text-gold-dark group-hover:text-gold transition-colors order-1">{item.outlet}</span>
              <span className="font-serif text-xl sm:text-2xl font-light col-span-2 sm:col-span-1 order-3 sm:order-2 group-hover:text-ivory transition-colors">
                {item.title}
              </span>
              <span className="text-navy/40 text-sm group-hover:text-ivory/60 transition-colors order-2 sm:order-3 text-right">{item.year}</span>
              <span className="text-navy/30 group-hover:text-gold transition-all group-hover:translate-x-1 order-4 text-right hidden sm:block">&#8599;</span>
            </motion.a>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-navy/45 text-sm max-w-xl">
            A selection of earned media placed for Park Communications clients. Active engagements are kept in
            confidence.
          </p>
          {!standalone && (
            <Link to="/engagements" data-testid="view-all-engagements" className="overline text-navy hover:text-gold-dark transition-colors whitespace-nowrap">
              Open the full engagements index &rarr;
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};
